import ApplicationSerializer from 'eflex/serializers/application';

export default class TriggerConfigSerializer extends ApplicationSerializer {
  attrs = {
    taskConfig: {
      deserialize: false,
      serialize: false,
    },
    station: {
      deserialize: false,
      serialize: false,
    },
    oeeButton: {
      deserialize: false,
      serialize: false,
    },
  };
}
